"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

import type { NavItemProps } from "../type";
import { cn } from "~/lib/utils";

const NavItem = ({ title, to }: NavItemProps) => {
  const pathName = usePathname();

  const cleanedPathname = pathName.startsWith("/ar/")
    ? pathName.replace(/^\/ar/, "")
    : pathName;

  const isActive = cleanedPathname.startsWith(to);

  return (
    <Link
      href={to}
      className={`border-e border-solid border-primary/10 ${
        isActive && "border-b bg-white"
      } relative hover:border-b hover:bg-white hover:text-primary`}
    >
      <div className="mx-2 lg:mx-4 flex h-full cursor-pointer flex-row items-center gap-3 rounded-lg tracking-widest md:mx-8">
        <p
          className={`${isActive && "text-primary"} font-semibold uppercase text-[10px] md:text-[12px]`}
        >
          {title}
        </p>
        {isActive && (
          <div
            className={cn(
              "absolute bottom-0 start-4 w-4 h-[0.0625rem] bg-secondary translate-y-1/2 opacity-0 transition-opacity duration-200 left-1/2 translate-x-1/2",
              isActive && "opacity-100 delay-700",
            )}
          />
        )}
        {/* // <div className="bg-active absolute bottom-[-1px] left-[45%] h-0.5 w-3" /> */}
      </div>
    </Link>
  );
};

export default NavItem;
